import { classNames } from '@/shared/lib/classnames/classnames';
import type { TimeSlotButtonProps } from '../../model/types';
export const TimeSlotButton: React.FC<TimeSlotButtonProps> = ({
  slot,
  isSelected,
  className,
  onClick,
  mini
}) => <button onClick={onClick} className={classNames(`flex flex-col items-center gap-2 text-textPrimary`, {}, [className])} data-testgroup="slot-booking" data-sentry-component="TimeSlotButton" data-sentry-source-file="TimeSlotButton.tsx">
    <span className={classNames('w-20 rounded-2lg py-3 text-center text-xs transition-colors md:w-full', {
    'slot-active bg-primary text-white': isSelected,
    'bg-bgSecondary text-textPrimary hover:bg-primary/30 active:bg-primary/75 active:text-white': !isSelected,
    'px-3 lg:px-7': mini
  })}>
      {slot}
    </span>
  </button>;